/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_TitleInputs */

const en_admin_ai_chat_title = /** @type {(inputs: Admin_Ai_Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Assistant`)
};

const de_admin_ai_chat_title = /** @type {(inputs: Admin_Ai_Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Assistent`)
};

const es_admin_ai_chat_title = /** @type {(inputs: Admin_Ai_Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistente de IA`)
};

const fr_admin_ai_chat_title = /** @type {(inputs: Admin_Ai_Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant IA`)
};

const nl_admin_ai_chat_title = /** @type {(inputs: Admin_Ai_Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assistent`)
};

/** @type {(inputs: Admin_Ai_Chat_TitleInputs) => LocalizedString} */
const it_admin_ai_chat_title = en_admin_ai_chat_title;

/** @type {(inputs: Admin_Ai_Chat_TitleInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_title = en_admin_ai_chat_title;

/** @type {(inputs: Admin_Ai_Chat_TitleInputs) => LocalizedString} */
const pl_admin_ai_chat_title = en_admin_ai_chat_title;

/** @type {(inputs: Admin_Ai_Chat_TitleInputs) => LocalizedString} */
const hu_admin_ai_chat_title = en_admin_ai_chat_title;

/** @type {(inputs: Admin_Ai_Chat_TitleInputs) => LocalizedString} */
const ro_admin_ai_chat_title = en_admin_ai_chat_title;

/**
* | output |
* | --- |
* | "AI Assistant" |
*
* @param {Admin_Ai_Chat_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_title = /** @type {((inputs?: Admin_Ai_Chat_TitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_TitleInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_title(inputs)
	if (locale === "de") return de_admin_ai_chat_title(inputs)
	if (locale === "es") return es_admin_ai_chat_title(inputs)
	if (locale === "fr") return fr_admin_ai_chat_title(inputs)
	if (locale === "nl") return nl_admin_ai_chat_title(inputs)
	if (locale === "it") return it_admin_ai_chat_title(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_title(inputs)
	if (locale === "pl") return pl_admin_ai_chat_title(inputs)
	if (locale === "hu") return hu_admin_ai_chat_title(inputs)
	return ro_admin_ai_chat_title(inputs)
});
export { admin_ai_chat_title as "admin.ai_chat.title" }